import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {

  constructor() {
  }

  // Async promise store (makes it easier to replace in later stages)
  public store( key: String, data : any ){

    let json = "";
    return new Promise(( resolve, reject ) => {
      try{
        json = JSON.stringify(data);
      }catch(e){
        return reject(e);
      }

      try{
        localStorage.setItem(key.toString(), json);
      }catch(e){
        return reject(e);
      }
      
      return resolve(true);
    }); 
  }

  public get ( key : String ){
    return new Promise((resolve,reject) => {
      return resolve(JSON.parse(localStorage.getItem(key.toString())));
    })
  }

  public exists ( key : String ){
    return new Promise((resolve, reject) => {
      return (localStorage.getItem(key.toString()) != null);
    })
  }

  public clear( key ){
    return new Promise((resolve,reject) => {
      localStorage.removeItem(key.toString());
      return resolve(true);
    })
  }

  public purge(){
    return new Promise((resolve,reject) => {
      localStorage.clear();
      return resolve(true);
    })
  }

}
